import React from "react";
import Move from "./Move";
import Hop from "./Hop";
import Flip from "./Flip";
import ErrorBoundary from "../ErrorBoundary";
import calc from "../../utils/calc";

export const HopAround = ({ children, to, duration = "1s", ...props }) => {
    return (
        <ErrorBoundary componentName="HopAround">
            <Move
                easing="linear"
                loop
                duration={duration}
                animation={{
                    "0%,75%": { transform: "translate(0,0)" },
                    "25%,50%": { transform: `translate(100px, 0)` },
                }}
            >
                <Hop
                    duration={duration}
                    loop
                    animation={{
                        "0%,5%,10%,15%,20%,25%": {
                            transform: "translate(0,0)",
                        },
                        "2.5%,7.5%,12.5%,17.5%,22.5%": {
                            transform: "translate(0,-10px)",
                        },
                        "50%,55%,60%,65%,70%,75%": {
                            transform: "translate(0,0)",
                        },
                        "52.5%,57.5%,62.5%,67.5%,72.5%": {
                            transform: "translate(0,-10px)",
                        },
                    }}
                >
                    <Flip
                        horizontal
                        duration={duration}
                        loop
                        animation={{
                            "0%,75%": { transform: "scaleX(1)" },
                            "25%,50%": { transform: `scaleX(-1)` },
                        }}
                    >
                        {children}
                    </Flip>
                </Hop>
            </Move>
        </ErrorBoundary>
    );
};

/*
import React from "react";
import { useSpring, animated } from "react-spring";
const HopAround = ({ children, width, ...props }) => {
  const { x } = useSpring({
    from: { x: 0 },
    x: 100
  });
  const getAnimationStyles = (anim) => {
    const styles = {
    transform: anim.to((value) => `translate(${value}%)`)
    };
    console.log(styles)
    return styles;
  };
  return (
    <div style={{ width: width }}>
      <animated.div>
        <div style={getAnimationStyles(x)}>{children}</div>
      </animated.div>
    </div>
  );
};
*/

/*
const HopAround = ({ children, width, ...props }) => {
  const style = useSpring({
    from: { transform: `translateX(0%)`, wait: 0 },
    to: async (next, cancel) => {
      await next({ transform: `translateX(100%)` })
      await next({ wait: 1 })
      await next({ transform: `translateX(0%)` })
      await next({ wait: 0 })
    },
    loop: true,
    delay: 1000,
    config: {
      duration: 1000
    }
  });
  return <div style={{ width: width }}><animated.div style={style}>{children}</animated.div></div>;
};
*/
export default HopAround;
